import PropTypes from 'prop-types';

import { CustomCheckbox } from '../Forms';

//
// NOTE: Consuming developer should not need to be aware of this component.
//       It should be unknown and invisible if it is to remain part of the codebase.
//
const FilterItem = ({ children, count, id }) => {
  const formattedCount = new Intl.NumberFormat().format(count);

  return (
    <CustomCheckbox field={id}>
      {children}
      <span className="ml-1">({formattedCount})</span>
    </CustomCheckbox>
  );
};

FilterItem.propTypes = {
  children: PropTypes.node.isRequired,
  count: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
};

export default FilterItem;
